import { useRef, useEffect } from 'react';
import MessageBubble from './MessageBubble';
import { Bot } from 'lucide-react';

const ChatMessages = ({ agent, messages, isTyping, widgetSettings, formatTimestamp }) => {
  const messagesEndRef = useRef(null);

  // Auto-scroll para o final das mensagens
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="flex-1 overflow-auto bg-gradient-to-b from-gray-50/50 to-white">
      <div className="max-w-5xl mx-auto p-6 lg:p-8 space-y-6">
        {messages.map((message) => (
          <div 
            key={message.id} 
            className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'} animate-fadeIn`}
          >
            <MessageBubble
              agent={agent}
              message={message} 
              widgetSettings={widgetSettings} 
              formatTimestamp={formatTimestamp}
            />
          </div>
        ))}
        
        {/* Indicador de digitação aprimorado */}
        {isTyping && (
          <div className="flex justify-start animate-fadeIn">
            <div className="flex items-end gap-3">
              {/* Avatar do agente */}
              <div className="w-10 h-10 rounded-2xl overflow-hidden bg-gradient-to-br from-indigo-100 to-green-100 p-0.5 flex-shrink-0">
                <div className="w-full h-full rounded-2xl overflow-hidden bg-white flex items-center justify-center">
                  {agent?.widget_settings?.logo_url ? (
                    <img 
                      src={agent.widget_settings.logo_url} 
                      alt={agent?.name} 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <Bot className="w-5 h-5 text-indigo-400" />
                  )}
                </div>
              </div>
              
              {/* Bolha de digitação */}
              <div className="bg-white rounded-3xl shadow-lg px-6 py-4 border border-gray-100">
                <div className="flex items-center gap-1">
                  <div className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-green-800 to-green-600 animate-pulse" style={{ animationDelay: '0ms' }}></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-green-800 to-green-600 animate-pulse" style={{ animationDelay: '200ms' }}></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-green-800 to-green-600 animate-pulse" style={{ animationDelay: '400ms' }}></div>
                </div>
              </div>
            </div>
          </div>
        )}
        
        <div ref={messagesEndRef} />
      </div>
      
      {/* CSS para animações */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default ChatMessages;